import { Component, OnInit } from '@angular/core';
import { Link } from '../models/link';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

    public links: Link[]  = [
        { url: '/presentation', text: 'Présentation' },
        // { url: '/nos-services', text: 'Nos services' },
        { url: '/reservation', text: 'Réservation' },
        { url: '/vos-avis', text: 'Vos témoignages' },
        { url: '/blog', text: 'Blog' },
        { url: '/contact', text: 'Contact' },

    ];

  constructor() { }

  ngOnInit() {
  }

}
